export default {
  home: {
    matchups: {
      today: "Enfrentamientos de hoy",
      thisWeek: "Enfrentamientos de esta semana",
      upcoming: "Próximos enfrentamientos",
    },
    actions: {
      showMore: "Mostrar más",
      showLess: "Mostrar menos",
    },
    empty: {
      parlayMinGames: "Todavía no hay tendencias disponibles. Se necesitan al menos 3 juegos.",
    },
    hundredPercentClub: {
      subtitle: "Props que acertaron en el 100% de los juegos",
    },
    advancedTools: {
      subtitles: {
        startingLineups: "Encuentra valor cuando cambian las alineaciones iniciales. Incluido con",
        injuryImpact: "Mira cómo las lesiones afectan a sus compañeros. Incluido con",
        opponentRank: "Aprovecha enfrentamientos defensivos favorables. Incluido con",
        startingPitchers: "Busca oportunidades contra lanzadores vulnerables. Incluido con",
        weatherReport: "Usa el viento y el clima a tu favor. Incluido con",
      },
    },
    predictionMarkets: {
      status: {
        loading: "Cargando mercados...",
        loadError: "No se pudieron cargar los mercados.",
      },
    },
    sidebar: {
      improveExperience: "Mejora tu experiencia con Linemate",
      getAccess: "OBTÉN ACCESO A JUGADAS AVANZADAS Y ANÁLISIS MÁS PROFUNDOS",
    },
  },
};
